function toggleFaq(element) {
  // element is now the .faq-item parent
  const clickedFaqQuestion = element.querySelector('.faq-question');
  const clickedFaqAnswer = clickedFaqQuestion.nextElementSibling;
  const clickedIconPlus = clickedFaqQuestion.querySelector('.icon-plus');
  const clickedIconMinus = clickedFaqQuestion.querySelector('.icon-minus');
  
  // Check if the clicked FAQ is currently open
  const isCurrentlyOpen = clickedFaqAnswer.style.display === 'block';
  
  // Get all FAQ items
  const allFaqItems = document.querySelectorAll('.faq-item');
  
  // Close all FAQs
  allFaqItems.forEach(faqItem => {
    const faqQuestion = faqItem.querySelector('.faq-question');
    const faqAnswer = faqQuestion.nextElementSibling;
    const iconPlus = faqQuestion.querySelector('.icon-plus');
    const iconMinus = faqQuestion.querySelector('.icon-minus');
    
    faqAnswer.style.display = 'none';
    iconPlus.style.display = 'inline';
    iconMinus.style.display = 'none';
  });
  
  // If the clicked FAQ was closed, open it now
  if (!isCurrentlyOpen) {
    clickedFaqAnswer.style.display = 'block';
    clickedIconPlus.style.display = 'none';
    clickedIconMinus.style.display = 'inline';
  }
}

// Attach event listeners to all FAQ items (parent)
document.addEventListener('DOMContentLoaded', function() {
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    item.addEventListener('click', function() {
      toggleFaq(this);
    });
  });
});

